import React from 'react';
import { FaSmile, FaMeh } from 'react-icons/fa';
import * as styles from './SkillStatusIcon.module.scss';
var SkillStatusIcon = function SkillStatusIcon(_ref) { var status = _ref.status; return status === 'good' ? /*#__PURE__*/ React.createElement(FaSmile, { className: styles.iconGood }) : /*#__PURE__*/ React.createElement(FaMeh, { className: styles.iconSoso }); };
export default SkillStatusIcon;
